module.exports = __webpack_public_path__ + "static/media/linkedin-icon-19.0e054d84.png";